export default __webpack_public_path__ + "img/equipments-standalone-banner0.asset.4411b0aa.png";